import { clientEnvModule } from "@/modules/client-env";
import { localStorageModule } from "@/modules/local-storage";
import type { CalendarConnectSource } from "@/domains/metrics/tracked-event";

/**
 * Returns the source platform where a calendar connection is being initiated.
 */
export const getCalendarConnectSource = (): CalendarConnectSource => {
  if (localStorageModule.readIosCalendarSetup()) return "ios";
  if (clientEnvModule.isDesktop()) return "desktop";
  return "web";
};
